// Importing Material-UI icons
import Dashboard from "@material-ui/icons/Dashboard"; // Dashboard icon
import SettingsIcon from "@material-ui/icons/Settings"; // Settings icon
import AssessmentIcon from "@material-ui/icons/Assessment"; // Assessment icon
import AssignmentIcon from "@material-ui/icons/Assignment"; // Assignment icon

// Importing custom SVG icon as a React component
import { ReactComponent as RiskManagementIcon } from "../../assets/svgIcons/RiskManagementIcon.svg"; // Custom Risk Management icon

// Array of icons with their corresponding names
export const iconArray = [
  {
    name: "Dashboard", // Name of the menu item
    icon: Dashboard, // Icon component for the menu item
  },
  {
    name: "Reports", // Name of the menu item
    icon: AssignmentIcon, // Icon component for the menu item
  },
  {
    name: "Setup", // Name of the menu item
    icon: SettingsIcon, // Icon component for the menu item
  },
  {
    name: "Residual", // Name of the menu item
    icon: AssessmentIcon, // Icon component for the menu item
  },
  {
    name: "Payment", // Name of the menu item
    icon: AssessmentIcon, // Icon component for the menu item
  },
  {
    name: "Risk Management", // Name of the menu item
    icon: RiskManagementIcon, // Custom SVG icon for the menu item
  },
  {
    name: "API Logs", // Name of the menu item
    icon: RiskManagementIcon, // Custom SVG icon for the menu item
  },
];
